import React, { useEffect, useState } from "react";
import { Col, Layout, Row } from "antd";
import Header from "../../Authorized/Header";
import { connect, useSelector } from "react-redux";
import Feedback from "../../Utilities/Feedback";
import JobCard from "../../Utilities/JobCard";
import { LoadingOutlined } from "@ant-design/icons";
import { getAllApplications } from "../../Redux/Consultant/reducer";
import constants from "../../Redux/constants";
import { Helmet } from "react-helmet";
import ConsultantProfileCompletion from "../Profile/ConsultantProfileCompletion";

const Applications = (props) => {
  const [loading, setLoading] = useState(true);
  const { getAllApplications } = props;
  const { applications } = useSelector((state) => state.consultantStore);
  useEffect(() => {
    const fetchAllApplications = async () => {
      const { responseStatus } = await getAllApplications();
      if (responseStatus === constants.status.success) {
        setLoading(false);
      }
    };
    fetchAllApplications();
  }, [getAllApplications]);
  return (
    <Layout>
      <Helmet title="My Applications | Unicon" />
      <Header />
      <Layout.Content>
        <Col>
          {loading ? (
            <Feedback
              icon={<LoadingOutlined />}
              title="Fetching Your Applications"
            ></Feedback>
          ) : (
            <Col>
              <ConsultantProfileCompletion />
              {!applications.length >= 1 ? (
                <Col
                  md={{ span: 11 }}
                  style={{
                    padding: "1vh",
                    background: "#ffffff",
                    border: "1px solid #f4f4f4",
                    margin: "2vh",
                    marginLeft: "auto",
                    marginRight: "auto",
                    borderRadius: "2vh",
                  }}
                >
                  <Row justify="center">
                    <Feedback title="No Applications Found" status="404" />
                  </Row>
                </Col>
              ) : (
                <Col>
                  {applications.map((eachJob) => (
                    <Col>
                      <JobCard
                        key={eachJob.applicationId}
                        id={eachJob.applicationId}
                        title={eachJob.title}
                        typeRequirement={eachJob.typeRequirement}
                        targetStartDate={eachJob.targetStartDate}
                        targetEndDate={eachJob.targetEndDate}
                        userId={eachJob.userId}
                        createdDate={eachJob.createdDate}
                        t24Release={eachJob.T24Release}
                        showApplication={true}
                      ></JobCard>
                    </Col>
                  ))}
                </Col>
              )}
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const mapDispatchToReducer = (dispatch) => {
  return {
    getAllApplications: () => dispatch(getAllApplications()),
  };
};

export default connect(null, mapDispatchToReducer)(Applications);
